export enum Action {
  QuickFlow = 'QuickFlow',
  SlowFlow = 'SlowFlow',
  Control = 'Control',
  Evaluation = 'Evaluation'
}
